import { formatNumberWithDotAndComma } from "@/utils/moneyFormatter";
import { ColumnDef } from "@tanstack/react-table";
import { MapPin } from "lucide-react";

export const columns: ColumnDef<CollectionOrder>[] = [
  {
    id: "rowNumber",
    header: "",
    cell: ({ row }) => {
      return <div className="text-left w-2 text-primary">{row.index + 1}</div>;
    },
    meta: { width: 10 },
  },
  {
    accessorKey: "Customer",
    header: "Customer",

    cell: ({ row }: any) => {
      const { commercial_name } = row.original.Customer;
      return <div className="text-left ">{commercial_name}</div>;
    },
    size: 10,
  },
  {
    accessorKey: "amount",
    header: () => <div className="text-left">Amount</div>,
    cell: ({ row }) => {
      const value: number = row.getValue("amount");
      const amount = formatNumberWithDotAndComma(value.toString());
      return (
        <div className="text-left font-semibold">
          {amount} <span className="text-sm font-normal">DZD</span>{" "}
        </div>
      );
    },
  },
  {
    accessorKey: "createdById",
    header: () => <div className="text-left">Created By</div>,
    cell: ({ row }) => {
      const { fullname } = row.original.CreatedBy as Employee;
      return <div className="text-left ">{fullname}</div>;
    },
  },

  {
    accessorKey: "collectorId",
    header: () => <div className="text-left">Collector</div>,
    cell: ({ row }: any) => {
      const { fullname } = row.original.Collector;
      return <div className="text-left ">{fullname}</div>;
    },
  },
  {
    accessorKey: "location",
    header: "Wilaya",
    cell: ({ row }) => {
      const wilaya = row.original.wilaya; // Access the wilaya field directly from row.original
      const coordinates = row.original.location; // Access location field directly from row.original
      const googleMapsUrl = `https://www.google.com/maps?q=${coordinates}`;

      return (
        <div className="flex">
          <p className="mr-2">{wilaya}</p> {/* Display wilaya */}
          {coordinates === "" ? null : ( // Display the map pin icon only if coordinates are available
            <a
              className="text-primary"
              href={googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MapPin size={20} className="inline" />
            </a>
          )}
        </div>
      );
    },
  },

  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => {
      const dateValue = new Date(row.getValue("date"));
      const today = new Date();

      // Calculate the difference in days between the date and today
      const oneDayInMs = 24 * 60 * 60 * 1000;
      const differenceInDays = Math.ceil(
        (dateValue.getTime() - today.getTime()) / oneDayInMs
      );

      const formattedDate = dateValue.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      let color = "inherit";
      if (differenceInDays === 0) {
        color = "red"; // due today
      } else if (differenceInDays === 1) {
        color = "#F7C74E"; // due tomorrow
      }

      // Apply color if the date is 1 day from today

      return (
        <div className="text-left" style={{ color }}>
          {formattedDate}
        </div>
      );
    },
  },
];
